<template>
  <div class="container mt-2">
    <v-img class="content" :src="require('@/assets/secretk.png')"></v-img>
  </div>
</template>

<script>
export default {
  name: "SecretK",
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.content {
  max-height: 480px;
}
</style>
